import { useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"
import { storeInformation } from "actions"

const useInformation = () => {
  const dispatch = useDispatch()
  return {
    information: useSelector((state) => state.information),
    storeInformation: useCallback(
      (info) => dispatch(storeInformation(info)),
      [dispatch]
    ),
  }
}

export default useInformation
